import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      return setError('Las contraseñas no coinciden');
    }
    if (newPassword.length < 8) {
      return setError('La contraseña debe tener al menos 8 caracteres');
    }

    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/auth/reset-password`, { token, newPassword });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.message || 'El enlace es inválido o ha expirado');
    } finally {
      setLoading(false);
    }
  };

  const brandMark = (
    <div className="login-image">
      <div className="login-brand-mark">
        <div className="login-brand-lockup">
          <span className="login-brand-name"><span className="accent">R</span>ENATA</span>
          <span className="login-brand-divider"></span>
          <span className="login-brand-sibling">TAXI</span>
        </div>
        <p className="login-brand-tagline">Taxi es la plataforma de gestión de EFE Company, hermana de Renata, tu asistente tributaria con IA.</p>
      </div>
    </div>
  );

  if (!token) {
    return (
      <div className="login-container">
        {brandMark}
        <div className="login-form-container">
          <div className="login-form">
            <p style={{ color: '#f87171' }}>Enlace inválido.</p>
            <Link to="/forgot-password" style={{ color: '#ffd700' }}>Solicitar nuevo enlace</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      {brandMark}
      <div className="login-form-container">
        <form onSubmit={handleSubmit} className="login-form">
          <h2><span className="accent-text">TAXI</span> te lleva al futuro de la contabilidad</h2>
          <p>Crear nueva contraseña</p>

          {success ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ color: '#ffd700', marginBottom: '16px' }}>
                ¡Contraseña actualizada correctamente!
              </p>
              <Link to="/login" style={{ display: 'block', marginTop: '8px', color: '#ffd700' }}>
                Ir al login
              </Link>
            </div>
          ) : (
            <>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Nueva contraseña (mín. 8 caracteres)"
                required
              />
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirmar contraseña"
                required
              />
              {error && <p style={{ color: 'red', fontSize: '13px' }}>{error}</p>}
              <button type="submit" disabled={loading}>
                {loading ? 'Guardando...' : 'Guardar nueva contraseña'}
              </button>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
